import {SDNO_CONTACTS_QUERY} from "../../data-subscription/queries.js";
import {
    SDNO_DAAP_COMPANIES_QUERY, SDNO_DAAP_EXISTING_DISTRIBUTOR_PLATFORM_SUBSCRIPTIONS_QUERY,
    SDNO_DAAP_EXISTING_SUBSCRIPTIONS_QUERY,
    SDNO_DAAP_METADATA_QUERY
} from "../graphql/queries.js";
import {
    SDNO_DAAP_SAVE_DISTRIBUTOR_PLATFORM_SUBSCRIPTION_MUTATION,
    SDNO_DAAP_SAVE_SUBSCRIPTION_MUTATION
} from "../graphql/mutations.js";
import {useMutation, useQuery} from "@apollo/client";

export const useContacts = (companySfid) => {
    return useQuery(SDNO_CONTACTS_QUERY, { variables: {companySfid, isActive: true, first: 1000}});
};

export const useDaapMetadata = () => {
    return useQuery(SDNO_DAAP_METADATA_QUERY, {
        variables: {},
        fetchPolicy: 'no-cache',
    });
};

export const useDaapSaveSubscriptions = () => {
    return useMutation(SDNO_DAAP_SAVE_SUBSCRIPTION_MUTATION, { fetchPolicy: 'no-cache'});
};

export const useDaapSaveDistributorPlatformSubscriptions = () => {
    return useMutation(SDNO_DAAP_SAVE_DISTRIBUTOR_PLATFORM_SUBSCRIPTION_MUTATION, { fetchPolicy: 'no-cache'});
};

export const useDaapExistingSubscriptions = (selectedContacts) => {
    return useQuery(SDNO_DAAP_EXISTING_SUBSCRIPTIONS_QUERY, {
        variables: {emails: selectedContacts},
        fetchPolicy: 'no-cache',
    });
}

export const useDaapExistingDistributorPlatformSubscriptions = (email) => {
    return useQuery(SDNO_DAAP_EXISTING_DISTRIBUTOR_PLATFORM_SUBSCRIPTIONS_QUERY, {
        variables: {emails: email},
        fetchPolicy: 'no-cache',
    });
}

export const useDaapCompanies = (dataSources) => {
    return useQuery(SDNO_DAAP_COMPANIES_QUERY, {
        variables: {dataSources},
        fetchPolicy: 'no-cache',
        skip: dataSources.length === 0,
    });
};
